export const isAreaInRange = (forestArea, range) => {
  const { min_ha, max_ha } = range;

  if (max_ha !== undefined) {
    return forestArea >= min_ha && forestArea <= max_ha;
  }

  return forestArea >= min_ha;
};

export const getTotalForestArea = (properties) => {
  if (!properties) return 0;

  return properties.reduce((total, prop) => total + prop?.forestArea ?? 0, 0);
};

export const mapPropertiesData = (properties) => {
  return properties.map((prop) => {
    const disabled =
      prop.type != "PROP" ||
      ["broken", "running"].includes(prop?.status) ||
      prop?.data?.overview_classification?.forest_land == 0 ||
      prop?.data?.forest_land == 0;

    const designation = disabled
      ? `${prop.designation} - Inte tillgänglig`
      : prop.designation;

    return {
      designation,
      ref: prop.ref,
      forestArea: prop?.forest_land ?? 0,
      plus_price_error: prop?.plus_price_error ?? 0,
      plus_price: prop?.plus_price ?? 0,
      plus_price_max: prop?.plus_price_max ?? 0,
      type: prop.type,
      lmID: prop?.lmID ?? null,
      dfr: prop?.dfr ?? false,
      hasBadData: prop?.has_bad_data ?? false,
      disabled,
    };
  });
};

export const saveOrderToCookie = (order) => {
  sessionStorage.setItem("subscription_order", JSON.stringify(order));
};

export const getOrderFromCookie = () => {
  const order = sessionStorage.getItem("subscription_order");
  if (!order) {
    return undefined;
  }
  return JSON.parse(order);
};

export const clearOrderFromCookie = () => {
  sessionStorage.removeItem("subscription_order");
};

const stepNames = ["order", "payment_selection", "thank_you"];

export const trackSubscriptionCheckoutEvent = (
  action,
  currentStep,
  properties
) => {
  const baseTrackingData = {
    category: "subscription",
    step: stepNames[currentStep - 1],
  };

  mixpanel.track(`subscription_checkout:${action}`, {
    ...baseTrackingData,
    ...properties,
  });

  gtag(
    "event",
    "fe_subscription_checkout:" + stepNames[currentStep - 1] + ":" + action,
    {
      method: "site",
    }
  );
};
